/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VaccinationSchedules } from './VaccinationSchedules';
import {
    VaccinationSchedulesFromJSON,
    VaccinationSchedulesFromJSONTyped,
    VaccinationSchedulesToJSON,
} from './VaccinationSchedules';

/**
 * 
 * @export
 * @interface VaccinationSchedulesPutResponse
 */
export interface VaccinationSchedulesPutResponse {
    /**
     * 
     * @type {Array<VaccinationSchedules>}
     * @memberof VaccinationSchedulesPutResponse
     */
    data?: Array<VaccinationSchedules>;
}

/**
 * Check if a given object implements the VaccinationSchedulesPutResponse interface.
 */
export function instanceOfVaccinationSchedulesPutResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VaccinationSchedulesPutResponseFromJSON(json: any): VaccinationSchedulesPutResponse {
    return VaccinationSchedulesPutResponseFromJSONTyped(json, false);
}

export function VaccinationSchedulesPutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaccinationSchedulesPutResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(VaccinationSchedulesFromJSON)),
    };
}

export function VaccinationSchedulesPutResponseToJSON(value?: VaccinationSchedulesPutResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(VaccinationSchedulesToJSON)),
    };
}

